/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect,useRef ,useLayoutEffect, useContext} from 'react'
import '../assets/styles/modal.scss'
import closeIcon from '../images/icons/Icon2.png'
import CreatableSelect from 'react-select/creatable';
import { useTranslation } from 'react-i18next';
import { customSelSearch} from '../utils/configs';
import CustomSelect from '../common/CustomSelect';
import useSidebarHidden from '../common/useSidebarHidden';
import { ThemeContext } from "../contexts/themeContext";
import { passwordRegex, emailRegex, mobileNumberRegex, storageUtil } from '../utils/commonFunctions';
import {useSuperAdminCheck} from "../utils/useSuperAdminCheck";
import { APIEndpoint } from '../utils/axios';

export const UpdateEmp = (props) => {

  const {fields,type, deptValues,newDeptAdd,newDesigAdd,setNewDeptAdd,setNewDesigAdd,desigValues,setSubmitFormChanges,section,updatedRoleDes,updatedRoleDep,setSection,resetPasswordchecked,selectSearchOptionsDesignation,setSelectSearchOptionsDepartment,selectSearchOptionsDepartment,setSelectSearchOptionsDesignation,setResetPasswordChecked,setModalFormStatusObj,cabinState,setCabinState,empState}=props;

  const [updated, setUpdated] = React.useState(null);
  const { t } = useTranslation();
  const inputRef=useRef(null)
  const [empPassword,setEmpPassword]=useState('');
  const [retypeEmpPassword,setRetypeEmpPassword]=useState('');
  const [FieldCautions,setFieldCautions]=useState({});
  const [userTypeFieldWidth,setUserTypeFieldWidth]=useState(18);
  const [FieldErrors,setFieldErrors]=useState({password:false,passwordConf:false,email:false,mobile:false});
  const [passwordUpdates,setPasswordUpdates]=useState({});
  const {themedColor} = useContext(ThemeContext);

  const [cloneFromUserId, setCloneFromUserId] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const {isSuperAdmin} = useSuperAdminCheck();

  const fetchClonePreview = async (userId) => {
    if (!userId) {
      setPreviewData(null);
      return;
    }
    setPreviewLoading(true);
    try {
      const resp = await APIEndpoint.get(`employees/${userId}/clone-preview`);
      if (resp.success) {
        setPreviewData(resp.result);
      } else {
        setPreviewData(null);
      }
    } catch {
      setPreviewData(null);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleSelectCloneUser = (selectedOption) => {
    const userId = selectedOption ? selectedOption.value : null;
    setCloneFromUserId(userId);
    fetchClonePreview(userId);
    setSubmitFormChanges(prev => ({
      ...prev,
      cloneFromUserId: userId
    }));
  };

  const cloneUserOptions = (props.employees || [])
    .filter(emp => emp.deleted !== true)
    .map(emp => ({
      value: emp.employeeId,
      label: `${emp.name} (${emp.employeeCode})`
    }));

  const getGroupedPermissions = (permissionsList) => {
    if (!permissionsList || permissionsList.length === 0) return null;
    const groups = {};
    permissionsList.forEach(p => {
      const match = p.match(/^([^-]+)\s*-\s*([^(]+)(?:\(([^)]+)\))?/);
      if (match) {
        const resource = match[1].trim();
        const action = match[2].trim();
        const effect = match[3] ? match[3].trim() : '';
        if (!groups[resource]) {
          groups[resource] = [];
        }
        groups[resource].push(`${action}${effect && effect !== 'allow' ? ' (' + effect + ')' : ''}`);
      } else {
        if (!groups['Other']) {
          groups['Other'] = [];
        }
        groups['Other'].push(p);
      }
    });
    return groups;
  };

  const renderPermissionsPreview = (permissionsList) => {
    const groups = getGroupedPermissions(permissionsList);
    if (!groups) return (
      <span style={{ color: '#6B7996', fontStyle: 'italic', fontSize: '12px' }}>No permissions configured</span>
    );
    return (
      <div style={{ maxHeight: '200px', overflowY: 'auto', paddingRight: '4px', marginTop: '6px' }}>
        {Object.keys(groups).map(resource => (
          <div key={resource} style={{ marginBottom: '10px' }}>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#9EAEC5',
              marginBottom: '5px',
              letterSpacing: '0.03em'
            }}>{resource}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
              {groups[resource].map((action, i) => (
                <span key={i} style={{
                  display: 'inline-block',
                  padding: '2px 9px',
                  borderRadius: '3px',
                  fontSize: '11px',
                  background: 'rgba(125,164,177,0.15)',
                  color: '#7DA4B1',
                  border: '1px solid rgba(125,164,177,0.25)',
                  fontWeight: '500'
                }}>{action}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderLocationsPreview = (locations) => {
    if (!locations || locations.length === 0)
      return <span style={{ color: '#6B7996', fontStyle: 'italic', fontSize: '12px' }}>No locations assigned</span>;
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '4px' }}>
        {locations.map((loc, i) => (
          <span key={i} style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: '3px',
            fontSize: '11px',
            background: 'rgba(125,164,177,0.12)',
            color: '#9EAEC5',
            border: '1px solid rgba(125,164,177,0.2)',
            fontWeight: '500'
          }}>{loc}</span>
        ))}
      </div>
    );
  };

  const sideBarHidden = useSidebarHidden('.content-container');
  const preCompile = {
    passwordReq: t('warningTexts.passwordReq'),
    passwordMatchCheck:t('warningTexts.passwordMatchCheck'),
    passwordNumeric:t('warningTexts.passwordNumeric'),
    emailValidity:t('warningTexts.emailValidity'),
    mobileNumberValidity:t('warningTexts.mobileNumberValidity'),
    newDepartmentAdd:t('warningTexts.employees.newDepartmentAdd'),
    newDesignationAdd:t('warningTexts.employees.newDesignationAdd'),

  }
useEffect(() => {
    checkPasswordFieldsValidity();
}, [passwordUpdates])

useLayoutEffect(() => {
  if (inputRef.current && typeof props.type === "string" && props.type.includes("ccount")) {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const widthInRem = Math.floor(inputRef.current.offsetWidth / rootFontSize);
    setUserTypeFieldWidth(widthInRem);
  }
}, []);

useEffect(() => {
if(deptValues||desigValues){
  setSection({department:deptValues,designation:desigValues})
}
}, [deptValues,desigValues])

useEffect(() => {
  if(updatedRoleDes || updatedRoleDep){
    if(updatedRoleDep){
      setNewDeptAdd(null);
    }
    if(updatedRoleDes){
      setNewDesigAdd(null);
    }
  }
}, [updatedRoleDes,updatedRoleDep])

useEffect(() => {
    buttonStatus(FieldErrors);
}, [FieldErrors])


const buttonStatus=(FieldErrors)=>{
  if(props.title.includes('User'))return false;
 return !Object.values(FieldErrors).every(v => v === false);
}

   let isError = false,
  isNotify = false,
  updateStatusText = '';
  if (props.modalFormStatusObj) {
    if (('text' in props.modalFormStatusObj)) {
      updateStatusText= props.modalFormStatusObj.text;
    }
    if (('error' in props.modalFormStatusObj)) {
      updateStatusText = props.modalFormStatusObj.error;
      isError = props.modalFormStatusObj.error;
    }
  }

  const checkPasswordFieldsValidity = () => {
    if (Object.keys(passwordUpdates).length > 0) {
      const isNumeric = (value) => /^\d+$/.test(value);
      if (!passwordUpdates.password?.length) {
        setFieldCautions((_) => ({ ..._, password: preCompile.passwordReq }));
        setFieldErrors({ ...FieldErrors, password: true });
      } else if (passwordUpdates.password&&!isNumeric(passwordUpdates.password)) {
        setFieldCautions((_) => ({ ..._, password: preCompile.passwordNumeric }));
        setFieldErrors({ ...FieldErrors, password: true });
      }
      if (isNumeric(passwordUpdates.password)&&!passwordUpdates.passwordConf?.length) {
        setFieldCautions((_) => ({ ..._, password: preCompile.passwordReq }));
        setFieldErrors({ ...FieldErrors, passwordConf: true });
      } else if (passwordUpdates.passwordConf&&!isNumeric(passwordUpdates.passwordConf)) {
        setFieldCautions((_) => ({ ..._, password: preCompile.passwordNumeric }));
        setFieldErrors({ ...FieldErrors, passwordConf: true });
      }
      if (
        passwordUpdates?.password?.length &&
        passwordUpdates?.passwordConf?.length &&
        passwordUpdates?.password !== passwordUpdates?.passwordConf
      ) {

        setFieldCautions((_) => ({ ..._, password: preCompile.passwordMatchCheck }));
        setFieldErrors({ ...FieldErrors, passwordConf: true, password: true });
      } else if (
        passwordUpdates?.password?.length &&
        passwordUpdates?.passwordConf?.length &&
        passwordUpdates?.password === passwordUpdates.passwordConf
      ) {
        setFieldErrors({ ...FieldErrors, passwordConf: false, password: false });
        setFieldCautions({});
      }
      else if (
        !passwordUpdates?.password?.length &&
        !passwordUpdates?.passwordConf?.length
      ) {
        setFieldErrors({ ...FieldErrors, passwordConf: false, password: false });
        setFieldCautions({});
      }
    }
  };

  const checkEmailValidity=(value)=>{
    return emailRegex.test(value);
  }
  const checkMobileNumberValidity=(value)=>{
    return mobileNumberRegex.test(value);
  }

  const handleChange = () => {
    setResetPasswordChecked(!resetPasswordchecked);
  };

  const onChangeCabinStates=(e)=>{
    const { name,checked } = e.target;
    if(name==='cabinCrew'){
      setCabinState({...cabinState,cabinCrew:checked})
    }
    if(name==='cabinCrewAdmin'){
      setCabinState({...cabinState,cabinCrewAdmin:checked})
    }
  }

  const onChangeEmp = (e) => {
    setModalFormStatusObj({text:""});
    const { name, value } = e.target;
    let newUpdates =  updated ? { ...updated } : {}
    if(name==='password' || name==='passwordConf'){
      if (name==='password' && (value === '' || passwordRegex.test(value) || value !=='')) {
        passwordUpdates[name] = value;
        setEmpPassword(value);
        newUpdates[name] = value;
      }
      if (name==='passwordConf' && (value === '' || passwordRegex.test(value) || value !=='')) {
        passwordUpdates[name] = value;
        setRetypeEmpPassword(value);
        newUpdates[name] = value;
      }
      setPasswordUpdates({...passwordUpdates})
      setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
      checkPasswordFieldsValidity();
    }
    else if(name==='email'){
    let res=checkEmailValidity(value);
    if(res){
      setFieldErrors({...FieldErrors,email:false});
      newUpdates[name] = value;
      setUpdated({...newUpdates});
      setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
    }
    else{
      setFieldErrors({...FieldErrors,email:true});
      setFieldCautions((_)=>({..._,email:preCompile.emailValidity}));
      newUpdates[name] = value;
      setUpdated({...newUpdates});
      setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
    }
    }
    else if(name==='mobile'){
      let res=checkMobileNumberValidity(value);
      if(res){
        setFieldErrors({...FieldErrors,mobile:false});
        newUpdates[name] = value;
        setUpdated({...newUpdates});
        setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
      }
      else{
        setFieldErrors({...FieldErrors,mobile:true});
        setFieldCautions((_)=>({..._,mobile:preCompile.mobileNumberValidity}));
        newUpdates[name] = value;
        setUpdated({...newUpdates,...section});
        setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
      }
      }
    else{
      newUpdates[name] = value;
      setUpdated({...newUpdates,...section});
      setSubmitFormChanges(prev => ({ ...prev, ...newUpdates,...passwordUpdates,...section}));
    }

  }
  const handleSelectDept=(e)=>{
   setSection({...section,department:e.value})


  }
  const handleSelectDesg=(e)=>{
    setSection({...section,designation:e.value})

  }
    const handleSelectUserType=(e)=>{
   setSection({...section,userType:e?.value??null})
  }
  useEffect( () => {
    if(!props.type.includes("ccount")){
      if (empState && empState[2] && empState[2].options) {
        setSelectSearchOptionsDepartment( empState[2].options.map(d=>{if(d.name){
          d.label=d.name
          }return d}));
      }
      if (empState && empState[3] && empState[3].options) {
        setSelectSearchOptionsDesignation( empState[3].options.map(d=>{if(d.name){
          d.label=d.name
          }return d}));
      }
    }
  }, [fields, empState] );

  useEffect( () => {
    if(!props.type.includes("ccount")){
      if (empState && empState[2] && empState[2].options) {
        setSelectSearchOptionsDepartment( empState[2].options);
      }
    }
  }, [fields,deptValues, empState] );

  useEffect( () => {
    if(!props.type.includes("ccount")){
      if (empState && empState[3] && empState[3].options) {
        setSelectSearchOptionsDesignation( empState[3].options);
      }
    }
  }, [fields,desigValues, empState] );

  useEffect( () => {
    if(!props.type.includes("ccount")){
      if (empState && empState[2] && empState[2].options && !empState[2].options.find(e=>e.value===section.department)){
        setSelectSearchOptionsDepartment([ ...empState[2].options,{key:null,name:section.department,value:section.department,label:section.department}]);
      }
    }
  }, [section.department, empState] );

  useEffect( () => {
    if(!props.type.includes("ccount")){
      if (empState && empState[3] && empState[3].options && !empState[3].options.find(e=>e.value===section.designation)){
        setSelectSearchOptionsDesignation([ ...empState[3].options,{key:null,name:section.designation,value:section.designation,label:section.designation}]);
      }
    }
  }, [section.designation, empState] );


const employeeUpdateFields=()=>{
  return(<>
         <h2 className="my-3 subheading-text-medium fontMedium margLeft18">Basic Details</h2>
          <div className="dialog__body_container flexRow justifyContentSpaceEvenly flexWrap">
            <div className='width40 floatLeft'>
               <div className="flexCol justifyContentSpaceBetween ">
                <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm15">
                  <label className="req">Employee Code</label>
                  <input
                    id='code'
                    type={'text'}
                    name="employeeCode"
                    placeholder={'Employee code'}
                    value={updated?updated[empState[0].attribute]:empState[0].initialValue?empState[0].initialValue:''}
                    onChange={onChangeEmp}
                    className='edit-input-employee'
                    />
                </div>
              </div>
            </div>
            <div  className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="select-employee-designation">Department</label>
                <CreatableSelect
                onChange={handleSelectDept}
                value={selectSearchOptionsDepartment.filter(function(option) {
                return option.value === section?.department;
                })}
                styles={{
                  ...customSelSearch(themedColor),
                  input: provided => ({
                          ...provided,
                          color: '#fff'
                        })
                }
              }
                options={selectSearchOptionsDepartment}
                isSearchable
                placeholder="Search or create a department..."
                />
                </div>
                {newDeptAdd?<h6 className="small-body-text-regular-label-upload">{`${newDeptAdd}  ${preCompile.newDepartmentAdd}`}</h6>:<></>}
              </div>
            </div>
            </div>


            <div className='width40 floatRight'>
                  <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="req">Name</label>
                  <input
                    id='name'
                    name="name"
                    placeholder={'Employee Name'}
                    type={'text'}
                    value={updated?updated[empState[1].attribute]:empState[1].initialValue?empState[1].initialValue:''}
                    onChange={onChangeEmp}
                    className='edit-input-employee'
                    />
                </div>
              </div>
            </div>


            <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                <label className="select-employee-designation">Designation</label>
                  <CreatableSelect
                  onChange={handleSelectDesg}
                  value={selectSearchOptionsDesignation.filter(function(option) {
                    return option.value === section?.designation;
                  })}
                  options={updatedRoleDes?updatedRoleDes:selectSearchOptionsDesignation}

                 styles={{
                                  ...customSelSearch(themedColor),
                                  input: provided => ({
                                          ...provided,
                                          color: '#fff'
                                        })
                                }
                              }
                  isSearchable
                  placeholder="Search or create a designation..."
                  />

                </div>
                {newDesigAdd?<h6 className="small-body-text-regular-label-upload">{`${newDesigAdd}  ${preCompile.newDesignationAdd}`}</h6>:<></>}
              </div>
            </div>
            </div>
          </div>

          <h2 className="my-3 subheading-text-medium fontMedium margLeft18">Contact Details</h2>

          <div className="dialog__body_container flexRow justifyContentSpaceEvenly flexWrap">
          <div className='width40'>
              <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Email</label>
                  <input id="email" type="text" placeholder={"Email Id"} className="edit-input-employee" name="email" attribute="email" onChange={onChangeEmp} value={updated?updated[empState[4].attribute]:empState[4].initialValue?empState[4].initialValue:''} />
                  {FieldErrors.email?<h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.email}</h6>:<></>}
                </div>
              </div>
            </div>

            <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Mobile</label>
                  <input id='mobile' type="text" placeholder={"Mobile (eg :+91-XXXXXXXXXX)"} className="edit-input-employee" name="mobile" attribute="amount" onChange={onChangeEmp} value={updated?updated[empState[5].attribute]:empState[5].initialValue?empState[5].initialValue:''} />
                     {FieldErrors.mobile?<h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.mobile}</h6>:<></>}
                </div>
              </div>
            </div>
            </div>
          <div className='width40'>
              <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Address</label>
                  <textarea rows="7" cols="40" name="address" placeholder={"Address"} onChange={onChangeEmp} value={updated?updated[empState[6].attribute]:empState[6].initialValue?empState[6].initialValue:''} className='edit-input-employee' />
                </div>
              </div>
            </div>
          </div>


          </div>

          <div className="dialog__body_container flexRow justifyContentSpaceEvenly flexWrap">
            {/* Left Column: Login Details */}
            <div className="width40">
              <h2 className="my-3 subheading-text-medium fontMedium" style={{ marginLeft: 0 }}>Login Details</h2>
              <div className="flexCol justifyContentSpaceEvenly">
                <div className="dialog__container_item input-container">
                  <div className="dialog__description margBtm16">
                    <label className="req">Username</label>
                    <input id="userName" type="text" placeholder={"Username"} className="edit-input-employee" onChange={onChangeEmp} value={updated?updated[empState[7].attribute]:empState[7].initialValue?empState[7].initialValue:''} name="userName" attribute="userName" />
                  </div>
                </div>

                {type === "AddNewEmployee" ? (
                  <>
                    <div className="dialog__container_item input-container">
                      <div className="dialog__description margBtm16">
                        <label className="req">Password</label>
                        <input id="pwd" type="password" placeholder={"Pin"} className="edit-input-employee" onChange={onChangeEmp} value={empPassword} name="password" attribute="password" />
                        {FieldErrors.password ? <h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.password}</h6> : null}
                      </div>
                    </div>

                    <div className="dialog__container_item input-container">
                      <div className="dialog__description margBtm16">
                        <label className="req">Re-type Password</label>
                        <input id="rtyPwd" type="password" placeholder={"Confirm Pin"} className="edit-input-employee" onChange={onChangeEmp} value={retypeEmpPassword} name="passwordConf" attribute="passwordConf" />
                        {FieldErrors.passwordConf ? <h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.password}</h6> : null}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="dialog__container_item input-container">
                    <div className="dialog__description__checkbox">
                      <input id="rstPwd" type={"checkbox"} value={resetPasswordchecked} onChange={handleChange} name="resetPassword" attribute="amount" />
                      <label className="margTop8">Reset Password</label>
                    </div>
                    <div className='flexCol'>
                      <div className="dialog__description__checkbox flexRow">
                        <input id="cc" type={"checkbox"} value={cabinState.cabinCrew} onClick={onChangeCabinStates} checked={cabinState.cabinCrew} name="cabinCrew" />
                        <label className="margTop8">Cabin Crew</label>
                      </div>
                      <div className="dialog__description__checkbox flexRow">
                        <input id="cca" type={"checkbox"} value={cabinState.cabinCrewAdmin} onClick={onChangeCabinStates} checked={cabinState.cabinCrewAdmin} name="cabinCrewAdmin" />
                        <label className="margTop8">Cabin Crew Admin</label>
                      </div>
                    </div>
                  </div>
                )}

                {resetPasswordchecked && (
                  <>
                    <div className="dialog__container_item input-container">
                      <div className="dialog__description margBtm16">
                        <label className="">New Password</label>
                        <input id="newPassword" type="password" placeholder={"Pin"} onChange={onChangeEmp} value={empPassword} className="edit-input-employee" name="password" attribute="password" />
                        {FieldErrors.password ? <h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.password}</h6> : null}
                      </div>
                    </div>
                    <div className="dialog__container_item input-container">
                      <div className="dialog__description margBtm16">
                        <label className="">Re-type Password</label>
                        <input id="retypeNewPassword" type="password" placeholder={"Confirm Pin"} onChange={onChangeEmp} value={retypeEmpPassword} className="edit-input-employee" name="passwordConf" attribute="passwordConf" />
                        {FieldErrors.passwordConf ? <h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.password}</h6> : null}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Right Column: Clone Authorization */}
            {type === "AddNewEmployee" && isSuperAdmin ? (
              <div className="width40">
                <h2 className="my-3 subheading-text-medium fontMedium" style={{ marginLeft: 0 }}>Clone Authorization</h2>
                <div className="flexCol justifyContentSpaceEvenly">
                  <div className="dialog__container_item input-container">
                    <div className="dialog__description margBtm16">
                      <label className="">Clone From User</label>
                      <button className='margTop8 flexRow justifyContentFlexStart saleType-div' style={{ width: '100%', border: 'none', background: 'transparent', padding: 0 }}>
                        <div style={{ width: '100%' }}>
                          <CreatableSelect
                            isClearable
                            onChange={handleSelectCloneUser}
                            options={cloneUserOptions}
                            value={cloneUserOptions.find(o => o.value === cloneFromUserId) || null}
                            placeholder="Search and select a user..."
                            styles={{
                              ...customSelSearch(themedColor),
                              input: provided => ({ ...provided, color: '#fff' })
                            }}
                          />
                        </div>
                      </button>
                      {previewLoading && (
                        <div style={{
                          marginTop: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          color: '#7DA4B1',
                          fontSize: '12px'
                        }}>
                          <span style={{
                            display: 'inline-block',
                            width: '10px', height: '10px',
                            border: '2px solid #7DA4B1',
                            borderTopColor: 'transparent',
                            borderRadius: '50%',
                            animation: 'spin 0.8s linear infinite'
                          }} />
                          Loading preview...
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    {!previewLoading && previewData ? (
                      <div style={{
                        background: 'rgba(28,43,64,0.7)',
                        border: '1px solid rgba(158,174,197,0.15)',
                        borderRadius: '6px',
                        padding: '12px 14px'
                      }}>
                        {/* Header */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginBottom: '10px',
                          paddingBottom: '8px',
                          borderBottom: '1px solid rgba(255,255,255,0.06)'
                        }}>
                          <span style={{ fontSize: '12px', fontWeight: '600', color: '#FFFFFFC2', letterSpacing: '0.02em' }}>
                            Access Preview
                          </span>
                        </div>

                        {/* Role */}
                        <div style={{ marginBottom: '10px' }}>
                          <span style={{ fontSize: '11px', color: '#6B7996', fontWeight: '500' }}>ROLE&nbsp;&nbsp;</span>
                          {previewData.roles && previewData.roles.length > 0 ? (
                            previewData.roles.map((r, i) => (
                              <span key={i} style={{
                                padding: '2px 9px',
                                borderRadius: '3px',
                                fontSize: '11px',
                                background: 'rgba(81,97,134,0.35)',
                                color: '#9CABD3',
                                border: '1px solid rgba(81,97,134,0.4)',
                                marginRight: '4px',
                                fontWeight: '500'
                              }}>{r.name}</span>
                            ))
                          ) : (
                            <span style={{ fontSize: '11px', color: '#6B7996', fontStyle: 'italic' }}>None</span>
                          )}
                        </div>

                        {/* Permissions */}
                        <div style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '11px', color: '#6B7996', fontWeight: '500', marginBottom: '4px' }}>PERMISSIONS</div>
                          {renderPermissionsPreview(previewData.permissions)}
                        </div>

                        {/* Locations */}
                        <div>
                          <div style={{ fontSize: '11px', color: '#6B7996', fontWeight: '500', marginBottom: '4px' }}>LOCATIONS</div>
                          {renderLocationsPreview(previewData.locations)}
                        </div>
                      </div>
                    ) : !previewLoading && !previewData ? (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '80px',
                        background: 'rgba(18,29,58,0.4)',
                        border: '1px dashed rgba(158,174,197,0.12)',
                        borderRadius: '6px',
                        color: '#4C5C81',
                        fontSize: '12px',
                        textAlign: 'center',
                        padding: '16px'
                      }}>
                        Select a user to preview their access
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
  </>)
}

const userAccountUpdateFields=()=>{
  return(<>
         <h2 className="my-3 subheading-text-medium fontMedium margLeft18">Basic Details</h2>
          <div className="dialog__body_container flexRow justifyContentSpaceEvenly flexWrap">
         <div className='width40 floatLeft'>
  <div className="flexCol justifyContentSpaceBetween">
    <div className="dialog__container_item input-container">
      <div className="dialog__description margBtm16">
        <label className="req">User Name</label>
        <input
          id='userName'
          ref={inputRef}
          type='text'
          name="userName"
          placeholder='User Name'
          disabled={empState[0].disabled??false}
          value={updated ? updated[empState[0].attribute] : empState[0].initialValue || ''}
          onChange={onChangeEmp}
          className='edit-input-employee'
        />
      </div>
    </div>



    <div className="dialog__container_item input-container">
      <div className="dialog__description margBtm16">
        <label className="req">User Type</label>
             <button  className='margTop8 flexRow justifyContentFlexStart saleType-div'>
              <CustomSelect
                options={empState[2].options}
                placeHolder={'Select User Type'}
                width={userTypeFieldWidth.toString()+'rem'}
                 value={empState[2].options?.filter(ut=> ut.value===section?.userType)}
                 onChange={handleSelectUserType}
              />
              </button>
      </div>
    </div>
  </div>
</div>



            <div className='width40 floatRight'>
                  <div className="flexCol justifyContentSpaceEvenly">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Name</label>
                  <input
                    id='name'
                    name="name"
                    placeholder={'Name'}
                    type={'text'}
                    value={updated?updated[empState[1].attribute]:empState[1].initialValue?empState[1].initialValue:''}
                    onChange={onChangeEmp}
                    className='edit-input-employee'
                    />
                </div>
              </div>
            </div>

            </div>



          </div>

          <h2 className="my-3 subheading-text-medium fontMedium margLeft18">Contact Details</h2>
          <div className="dialog__body_container flexRow justifyContentSpaceEvenly flexWrap">
          <div className='width40'>
              <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Email</label>
                  <input id="email" type="text" placeholder={"Email Id"} className="edit-input-employee" name="email" attribute="email" onChange={onChangeEmp} value={updated?updated[empState[3].attribute]:empState[3].initialValue?empState[3].initialValue:''} />
                  {FieldErrors.email?<h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.email}</h6>:<></>}
                </div>
              </div>
            </div>

            <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Mobile</label>
                  <input id='mobile' type="text" placeholder={"Mobile (eg :+91-XXXXXXXXXX)"} className="edit-input-employee" name="mobile" attribute="amount" onChange={onChangeEmp} value={updated?updated[empState[4].attribute]:empState[4].initialValue?empState[4].initialValue:''} />
                     {FieldErrors.mobile?<h6 className="small-body-text-regular-label-upload text-danger">{FieldCautions.mobile}</h6>:<></>}
                </div>
              </div>
            </div>
            </div>
          <div className='width40'>
              <div className="flexCol justifyContentSpaceEvenly ">
              <div className=" dialog__container_item input-container">
                <div className="dialog__description margBtm16">
                  <label className="">Address</label>
                  <textarea rows="7" cols="40" name="address" placeholder={"Address"} onChange={onChangeEmp} value={updated?updated[empState[5].attribute]:empState[5].initialValue?empState[5].initialValue:''} className='edit-input-employee' />
                </div>
              </div>
            </div>
          </div>


          </div>
  </>)
}
  return (
      <div className="overlay" role="dialog">
      <div className={`${ sideBarHidden ? 'dialog-fs2' : 'dialog'} sm-scrollbar`}>
        <div className="dialog__content">
  <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
          <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50">{props.title}</h2>
              <button className='close-btn-ht' onClick={props.onClose}>
                <img src={closeIcon} alt="close" data-icon='close'/>
              </button>
        </div>

          <hr />

          {!props.type.includes("ccount")?employeeUpdateFields():userAccountUpdateFields()}
        {Boolean(updateStatusText) ?
          <>
             <div className={"dialog__statusBlock " + (isError ? 'alert_error' : isNotify ?'alert_notify': 'alert_success')}>
              {updateStatusText}
            </div>
          </> : null }
        </div>
          <div className="dialog__footer flexCol alignItemsCenter">
          <button  disabled={buttonStatus(FieldErrors) || previewLoading} className="done-button" onClick={props.onSubmit}>{props.title === 'Edit Item' ? 'Update' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}

export const UpdateEmployeeModal = (props) => {
  const [resetPasswordchecked, setResetPasswordChecked] = React.useState(false);
  const [empState, setEmpState] = React.useState(props.fields?props.fields:[]);
  const [cabinState,setCabinState]=React.useState({});
  const [section,setSection]=useState({department:null,designation:null});
  const [updatedRoleDep, setUpdatedRoleDep] = React.useState(null);
  const [updatedRoleDes, setUpdatedRoleDes] = React.useState(null);
  const [submitFormChanges,setSubmitFormChanges]=React.useState({});
  const [deptValues,setDeptValues]=React.useState(null);
  const [desigValues,setDesigValues]=React.useState(null);
  const [selectSearchOptionsDepartment, setSelectSearchOptionsDepartment] = useState([]);
  const [selectSearchOptionsDesignation, setSelectSearchOptionsDesignation] = useState([]);

  useEffect( () => {
    if(props.type!=='AddNewEmployee'&& !props.type.includes("ccount")){
      const ccField  = props.fields && props.fields.find(f => f.attribute === 'cabinCrew');
      const ccaField = props.fields && props.fields.find(f => f.attribute === 'cabinCrewAdmin');
      const ccVal  = ccField  ? ccField.initialValue  : false;
      const ccaVal = ccaField ? ccaField.initialValue : false;
      setCabinState({cabinCrew: ccVal || false, cabinCrewAdmin: ccaVal || false})
    };
  }, [props.fields] );

  useEffect( () => {
   if(props.fields && props.fields.length >= 4 && props.type!=='AddNewEmployee' && !props.type.includes("ccount")){
    setEmpState(props.fields);
    setDeptValues(props.fields[2]?.value || props.fields[2]?.initialValue || '');
    setDesigValues(props.fields[3]?.value || props.fields[3]?.initialValue || '');
   }
   if(props.type.includes("ccount") && props?.fields && props.fields[2]?.initialValue){
    setSection((_)=>({..._,userType:props.fields[2].initialValue}))
   }
  }, [props.fields] );

  const onSubmit = async () => {
    props.onSubmit({...submitFormChanges,...cabinState,...section});
    removeContainerOverlay();
  }

const onChangeSelectSearchDepartment = (selectedValue, data) => {
  const depObj = empState && empState[2] && empState[2].options ? empState[2].options.find(dep => dep.name === selectedValue) : null;
  if (depObj) {
    setUpdatedRoleDep(depObj.value);
    let newUpdates={};
    newUpdates['department'] =depObj.value ;
    props.setSelectionDepartment({ ...newUpdates});
  }
};
const onChangeSelectSearchDesignation = (selectedValue,data) => {
  const desObj = empState && empState[3] && empState[3].options ? empState[3].options.find(des => des.name === selectedValue) : null;
  if (desObj) {
    setUpdatedRoleDes(desObj.value);
    let newUpdates = {}
    newUpdates['designation'] =desObj.value ;
    props.setSelectionDesignation({ ...newUpdates});
  }
};

  const onChange = (e, updated) => {
    typeof (props.onChange) === 'function' && props.onChange(e, updated)
  }

  const onClose = (e) => {
    removeContainerOverlay();
    setDesigValues(null);
    setDeptValues(null);
    props.onClose();
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };

  return (
    <UpdateEmp
      type={props.type}
      title={props.title}
      fields={props.fields}
      resetPasswordchecked={resetPasswordchecked}
      setResetPasswordChecked={setResetPasswordChecked}
      onChangeSelectSearchDepartment={(e)=>onChangeSelectSearchDepartment(e)}
      onChangeSelectSearchDesignation={(e)=>onChangeSelectSearchDesignation(e)}
      onChange={(e,updated) =>onChange(e,updated)}
      deptValues={deptValues}
      modalFormStatusObj={props.modalFormStatusObj}
      setModalFormStatusObj={props.setModalFormStatusObj}
      setDeptValues={setDeptValues}
      setSubmitFormChanges={setSubmitFormChanges}
      desigValues={desigValues}
      newDeptAdd={props.newDeptAdd}
      setNewDeptAdd={props.setNewDeptAdd}
      newDesigAdd={props.newDesigAdd}
      setNewDesigAdd={props.setNewDesigAdd}
      setDesigValues={setDesigValues}
      empState={empState}
      updatedRoleDep ={updatedRoleDep}
      setUpdatedRoleDep={setUpdatedRoleDep}
      updatedRoleDes ={updatedRoleDes}
      setUpdatedRoleDes={setUpdatedRoleDes}
      setEmpState={setEmpState}
      cabinState={cabinState}
      setCabinState={setCabinState}
      section={section}
      setSection={setSection}
      selectSearchOptionsDepartment={selectSearchOptionsDepartment}
      setSelectSearchOptionsDepartment={setSelectSearchOptionsDepartment}
      selectSearchOptionsDesignation={selectSearchOptionsDesignation}
      setSelectSearchOptionsDesignation={setSelectSearchOptionsDesignation}
      onClose={onClose}
      employees={props.employees}
      onSubmit={onSubmit}>
    </UpdateEmp>
  )
}
